import { render, staticRenderFns } from "./dam.vue?vue&type=template&id=97b86344&scoped=true&"
import script from "./dam.vue?vue&type=script&lang=js&"
export * from "./dam.vue?vue&type=script&lang=js&"
import style0 from "./dam.vue?vue&type=style&index=0&id=97b86344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b86344",
  null
  
)

export default component.exports